const MONEY_FIELDS = `
    amount
    currencyCode
`;

const IMAGE_FIELDS = `
    url
    altText
    width
    height
`;

const PRODUCT_FIELDS = `
    id
    handle
    title
    description
    descriptionHtml
    productType
    tags
    vendor
    availableForSale
    createdAt
    featuredImage { ${IMAGE_FIELDS} }
    images(first: 20) {
        edges { node { ${IMAGE_FIELDS} } }
    }
    priceRange {
        minVariantPrice { ${MONEY_FIELDS} }
        maxVariantPrice { ${MONEY_FIELDS} }
    }
    compareAtPriceRange {
        minVariantPrice { ${MONEY_FIELDS} }
        maxVariantPrice { ${MONEY_FIELDS} }
    }
    options { id name values }
    variants(first: 100) {
        edges {
            node {
                id
                title
                availableForSale
                quantityAvailable
                sku
                price { ${MONEY_FIELDS} }
                compareAtPrice { ${MONEY_FIELDS} }
                selectedOptions { name value }
                image { ${IMAGE_FIELDS} }
            }
        }
    }
`;

const CART_FIELDS = `
    id
    checkoutUrl
    totalQuantity
    cost {
        subtotalAmount { ${MONEY_FIELDS} }
        totalAmount { ${MONEY_FIELDS} }
    }
    lines(first: 250) {
        edges {
            node {
                id
                quantity
                cost {
                    totalAmount { ${MONEY_FIELDS} }
                }
                merchandise {
                    ... on ProductVariant {
                        id
                        title
                        image { ${IMAGE_FIELDS} }
                        price { ${MONEY_FIELDS} }
                        product { id handle title }
                    }
                }
            }
        }
    }
`;

const ARTICLE_FIELDS = `
    id
    handle
    title
    excerpt
    contentHtml
    publishedAt
    tags
    image { ${IMAGE_FIELDS} }
    author { name }
    blog { handle title }
`;

export const PRODUCTS_QUERY = `
    query Products($first: Int!, $query: String, $sortKey: ProductSortKeys, $reverse: Boolean) {
        products(first: $first, query: $query, sortKey: $sortKey, reverse: $reverse) {
            edges { node { ${PRODUCT_FIELDS} } }
            pageInfo { hasNextPage endCursor }
        }
    }
`;

export const COLLECTION_PRODUCTS_QUERY = `
    query CollectionProducts($handle: String!, $first: Int!, $sortKey: ProductCollectionSortKeys, $reverse: Boolean) {
        collection(handle: $handle) {
            products(first: $first, sortKey: $sortKey, reverse: $reverse) {
                edges { node { ${PRODUCT_FIELDS} } }
                pageInfo { hasNextPage endCursor }
            }
        }
    }
`;

export const PRODUCT_BY_HANDLE_QUERY = `
    query ProductByHandle($handle: String!) {
        product(handle: $handle) { ${PRODUCT_FIELDS} }
    }
`;

export const PRODUCT_RECOMMENDATIONS_QUERY = `
    query ProductRecommendations($productId: ID!) {
        productRecommendations(productId: $productId) { ${PRODUCT_FIELDS} }
    }
`;

export const PRODUCT_TYPES_QUERY = `
    query ProductTypesForTag($query: String) {
        products(first: 250, query: $query) {
            edges { node { productType } }
        }
    }
`;

export const COLLECTIONS_QUERY = `
    query Collections {
        collections(first: 250) {
            edges {
                node {
                    id
                    handle
                    title
                    description
                    image { ${IMAGE_FIELDS} }
                }
            }
        }
    }
`;

export const COLLECTION_BY_HANDLE_QUERY = `
    query CollectionByHandle($handle: String!) {
        collection(handle: $handle) {
            id
            handle
            title
            description
            image { ${IMAGE_FIELDS} }
        }
    }
`;

export const BLOGS_WITH_ARTICLES_QUERY = `
    query BlogsWithArticles($articlesFirst: Int!) {
        blogs(first: 50) {
            edges {
                node {
                    handle
                    articles(first: $articlesFirst, sortKey: PUBLISHED_AT, reverse: true) {
                        edges { node { ${ARTICLE_FIELDS} relatedProducts: metafield(namespace: "custom", key: "related_products") { value } } }
                    }
                }
            }
        }
    }
`;

export const CART_CREATE_MUTATION = `
    mutation CartCreate {
        cartCreate {
            cart { ${CART_FIELDS} }
            userErrors { field message }
        }
    }
`;

export const CART_QUERY = `
    query Cart($id: ID!) {
        cart(id: $id) { ${CART_FIELDS} }
    }
`;

export const CART_LINES_ADD_MUTATION = `
    mutation CartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
        cartLinesAdd(cartId: $cartId, lines: $lines) {
            cart { ${CART_FIELDS} }
            userErrors { field message }
        }
    }
`;

export const CART_LINES_UPDATE_MUTATION = `
    mutation CartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
        cartLinesUpdate(cartId: $cartId, lines: $lines) {
            cart { ${CART_FIELDS} }
            userErrors { field message }
        }
    }
`;

export const CART_LINES_REMOVE_MUTATION = `
    mutation CartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
        cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
            cart { ${CART_FIELDS} }
            userErrors { field message }
        }
    }
`;
